import * as yup from "yup";
import { type TFunction } from "i18next";

const ALLOWED_FILE_TYPES = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
const MAX_CARACTERES_JUSTIFICACION = 300;

// Tipo específico para el schema de Yup
export interface ActualizarPerfilSchemaValues {
  matriculaAbogado: string;
  fechaMatricula: string;
  justificacion: string;
  archivoEvidencia: File | null;
}

export const createActualizarPerfilFormSchema = (t: TFunction) => yup.object().shape({
  matriculaAbogado: yup
    .string()
    .required(t('actualizarPerfil.validation.matriculaRequired'))
    .matches(/^[0-9]{4,10}$/, t('actualizarPerfil.validation.matriculaFormat'))
    .trim(),
  
  fechaMatricula: yup
    .string()
    .required(t('actualizarPerfil.validation.fechaRequired'))
    .test('fecha-valida', t('actualizarPerfil.validation.fechaInvalid'), (value) => {
      if (!value) return false;
      const fecha = new Date(value);
      return !isNaN(fecha.getTime());
    })
    .test('fecha-pasada', t('actualizarPerfil.validation.fechaFuture'), (value) => {
      if (!value) return false;
      const fecha = new Date(value);
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
      return fecha < hoy;
    }),
  
  justificacion: yup
    .string()
    .required(t('actualizarPerfil.validation.justificacionRequired'))
    .min(50, t('actualizarPerfil.validation.justificacionMin'))
    .max(MAX_CARACTERES_JUSTIFICACION, t('actualizarPerfil.validation.justificacionMax', { max: MAX_CARACTERES_JUSTIFICACION }))
    .trim(),
  
  archivoEvidencia: yup
    .mixed<File | null>()
    .nullable()
    .test('archivo-requerido', t('actualizarPerfil.validation.archivoRequired'), (value) => {
      return value instanceof File;
    })
    .test('tipo-archivo', t('actualizarPerfil.validation.archivoType'), (value) => {
      if (!value) return false;
      return ALLOWED_FILE_TYPES.includes((value as File).type);
    })
    .test('tamano-archivo', t('actualizarPerfil.validation.archivoSize'), (value) => {
      if (!value) return false;
      return (value as File).size <= MAX_FILE_SIZE;
    }) as yup.MixedSchema<File | null>,
});
